import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { Alert } from 'bootstrap';

import '../components/axios.js';
import { getPublicUrl, getWwwUrl } from '../components/utils.js';
import ReCaptchaService from '../services/recaptcha-service.js';

window.dataLayer = window.dataLayer || [];

class Category {
	constructor() {
		console.log('Category page loaded');
		window.reCaptchaService = this.reCaptchaService = new ReCaptchaService();
		this.reCaptchaService.init(); // TODO: it can be deleted after public.js isn't used anymore

        this.filterForm = document.getElementById('filterForm');
        this.moreButton = document.getElementById('more-button');
        this.companyList = document.querySelector('#primary .list-body');
        this.url = getPublicUrl() + '/api' + window.location.href.replace(getPublicUrl(), '').replace(getWwwUrl(), '').replace('/v2', '').split('?')[0];
        this.page = 1;

        this.initEventListeners();
	}

	initEventListeners() {
		this.filterForm.addEventListener('change', (e) => {
			e.preventDefault();
			this.companyList.classList.add('loading');
			this.filterCompanies(() => {
				this.companyList.classList.remove('loading');
			});
		});

        this.filterForm.addEventListener('submit', (e) => {
            e.preventDefault();
            this.companyList.classList.add('loading');
            this.filterCompanies(() => {
                this.companyList.classList.remove('loading');
            });
        });

        this.moreButton.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.moreButton.classList.contains('loading')) {
                return false;
            }
            this.moreButton.classList.add('loading');
            this.moreCompanies(() => {
                this.moreButton.classList.remove('loading');
            });
        });
    }

    moreCompanies(callback) {
		let data = new FormData(this.filterForm);
		data.append('page', ++this.page);
		this.companyList.classList.add('loading');
        this.reCaptchaService.runWithCaptcha(
            "category_companies_page",
            (token, withCheckbox = false) => {
				data.append('recaptcha_token', token);
				data.append('recaptcha_checkbox', withCheckbox);
                return axios
                    .post(this.url, data)
                    .then((response) => {
                        console.log("category_companies_page", response);
                        this.companyList.insertAdjacentHTML('beforeend', response.data.html);
                        this.checkAvailablePages(response.data.canPaginate);
						this.companyList.classList.remove('loading');
                        if (callback) callback();
                    })
                    .catch((error) => {
                        console.error("category_companies_page", error);
						this.companyList.classList.remove('loading');
                        if (callback) callback();
                    });
            }
        );
    }

    filterCompanies(callback) {
		this.page = 1;
		let data = new FormData(this.filterForm);
		data.append('page', this.page);
		console.log('filterCompanies', data);
		this.companyList.classList.add('loading');
        this.reCaptchaService.runWithCaptcha(
            "category_companies_filter",
            (token, withCheckbox = false) => {
				data.append('recaptcha_token', token);
				data.append('recaptcha_checkbox', withCheckbox);
                return axios
                    .post(`${this.url}?filter=${Date.now()}`, data)
                    .then((response) => {
                        console.log("category_companies_filter", response);
                        this.companyList.innerHTML = response.data.html;
                        this.checkAvailablePages(response.data.canPaginate);
                        document.querySelector('#primary .list-header > span').textContent = response.data.records;
						this.companyList.classList.remove('loading');
                        if (callback) callback();
                    })
                    .catch((error) => {
                        console.error("category_companies_filter", error);
						this.companyList.classList.remove('loading');
                        if (callback) callback();
                    });
            }
        );
    }

    checkAvailablePages(canPaginate = true) {
        if (this.moreButton) {
            this.moreButton.style.display = canPaginate ? 'inline-block' : 'none';
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
	new Category();
});